// logic flow自定义的边,这里修改样式,修改样式都是在model里面修改，需要同时定义edge和model
import {PolylineEdge, PolylineEdgeModel} from "@logicflow/core";
class CustomerPolyline extends PolylineEdge{

}

class CustomerPolylineModel extends PolylineEdgeModel{
    // 自定义边样式：颜色、宽度、线段类型等，如果关系线是多分支的，那么必须设置关联条件，否则将线的颜色显示为红色
    getEdgeStyle() {
        const style = super.getEdgeStyle();
        // 如果关联关系有问题，那么将线显示为红色
        let properties = this.properties;
        if (properties.invalid) {
            style.stroke = "var(--el-color-danger)";
        }
        return style;
    }
}

export default {
    model: CustomerPolylineModel,
    type: "CustomerPolyline",
    view: CustomerPolyline,
}